import { FC } from 'react';
import { useResponsive } from 'v3/common/hooks/useResponsive';
import tenantChart from '../configs/tenant/chart.json';
import Lottie from 'lottie-react';
import _ from 'lodash';
import ApplicationDomainUtility from 'v3/common/utils/applicationDomain';
import { getData } from '../configs';

const locale = ApplicationDomainUtility.locale;

type ChartProps = {
  productName: string;
};

const Chart: FC<ChartProps> = ({ productName }) => {
  const isMobile = useResponsive();
  const chartLottie = ApplicationDomainUtility.isB2b ? tenantChart : getData(locale, 'chart');
  return (
    <div className="row strategy-tools__card">
      <div className="card card-yellow">
        <h3>Options Basket</h3>
        <p>
          {_.capitalize(ApplicationDomainUtility.partnerName) || productName}’s unique industry-first Options Basket helps
          you track total net premium across multi-leg option strategies. Monitor premium charts in real time,
          apply indicators, and automate trades with full visibility into your combined option position.
        </p>

        <ul>
          <li>Live candlestick chart of combined option premium</li>
          <li>Apply RSI, MACD and Moving Averages to premium data</li>
          <li>Set trade rules based on premium and indicator signals</li>
        </ul>
        {!isMobile && <Lottie animationData={chartLottie} loop className="chart-lottie" />}
      </div>
    </div>
  );
};

export default Chart;
